// extracted by mini-css-extract-plugin
module.exports = {"articleTitle":"ArticleHeader_articleTitle__Ot_pn","articleDate":"ArticleHeader_articleDate__r7UAq","componentStyle":"ArticleHeader_componentStyle__8_EUR"};